/* Outdoors Nordic. Flyttad ur blocks/on-product-bullets.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
if (customElements.get('on-product-bullets')) return;
class OnProductBullets extends HTMLElement {
connectedCallback() {
 if (this._init) { if (this._fit) window.addEventListener('resize', this._fit); return; }
 this._init = true;
 this.track = this.querySelector('[data-pb-track]');
 if (!this.track) return;
 var mode = this.getAttribute('data-layout') || 'stacked';
 if (mode === 'stacked') { this.bindFit(); return; }
 this.bindDrag();
 if (mode === 'auto') {
   var sp = parseFloat(this.getAttribute('data-speed'));
   if (isNaN(sp) || sp <= 0) sp = 0.6;
   this.startAuto(sp);
 }
}
/* SKYDD MOT RADBRYTNING (Victor 2026-10-17). Far en punkt inte plats pa en rad
  krymps texten nagot i stallet, men aldrig under 12 px och aldrig med "...".
  Ryms den inte ens da och listan star i tva kolumner, vaxlar listan till en
  kolumn (Victors beslut A 2026-10-17). En punkt som inte ryms ens i en kolumn
  vid 12 px far bryta som forut. Kors direkt, nar typsnittet laddats och efter
  storleksandring (setTimeout, ingen MutationObserver). */
bindFit() {
 var self = this, t = null;
 this._fit = function () { clearTimeout(t); t = setTimeout(function () { self.fit(); }, 150); };
 this.fit();
 if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fit(); });
 window.addEventListener('resize', this._fit);
}
fit() {
 var tr = this.track;
 tr.style.gridTemplateColumns = '';
 if (this.shrink()) return;
 if (getComputedStyle(tr).gridTemplateColumns.split(' ').length < 2) return;
 tr.style.gridTemplateColumns = '1fr';
 this.shrink();
}
/* Krymper varje punkt som inte ryms; svarar true om alla ryms pa en rad. */
shrink() {
 var MIN = 12, ok = true, items = this.track.querySelectorAll('.on-pb__item');
 for (var i = 0; i < items.length; i++) {
   var li = items[i], tx = li.querySelector('.on-pb__tx'), ic = li.querySelector('.on-pb__ic');
   if (!tx) continue;
   tx.style.fontSize = '';
   var base = parseFloat(getComputedStyle(tx).fontSize);
   var gap = parseFloat(getComputedStyle(li).columnGap) || 0;
   var avail = li.clientWidth - (ic ? ic.getBoundingClientRect().width + gap : 0);
   tx.style.whiteSpace = 'nowrap';
   var need = tx.getBoundingClientRect().width;
   if (avail > 0 && need > avail) {
     var size = Math.max(MIN, Math.floor(base * (avail - 1) / need * 2) / 2);
     if (size >= base) size = base;
     for (var k = 0; k < 12; k++) {
       tx.style.fontSize = size + 'px';
       need = tx.getBoundingClientRect().width;
       if (size <= MIN || need <= avail) break;
       size = Math.max(MIN, size - 0.5);
     }
     if (need > avail) ok = false;
   }
   tx.style.whiteSpace = '';
 }
 return ok;
}
/* Mus pa dator: overflow-x racker inte, det finns inget att dra i och hjulet
  scrollar sidan. Pekaren fangas FORST efter 4 px rorelse - fangas den redan
  vid pointerdown byter det efterfoljande klicket maltavla. */
bindDrag() {
 var el = this.track, down = false, moved = false, x0 = 0, s0 = 0, pid = null;
 el.addEventListener('pointerdown', function (e) {
   if (e.button !== 0) return;
   down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft; pid = e.pointerId;
 });
 el.addEventListener('pointermove', function (e) {
   if (!down) return;
   var dx = e.clientX - x0;
   if (!moved && Math.abs(dx) < 4) return;
   if (!moved) { moved = true; el.classList.add('is-dragging'); try { el.setPointerCapture(pid); } catch (err) {} }
   el.scrollLeft = s0 - dx; e.preventDefault();
 });
 function up() { down = false; if (moved) setTimeout(function () { el.classList.remove('is-dragging'); }, 0); moved = false; }
 ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { el.addEventListener(ev, up); });
 el.addEventListener('wheel', function (e) {
   if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
   var max = el.scrollWidth - el.clientWidth;
   if (max <= 0) return;
   var next = el.scrollLeft + e.deltaY;
   if (next < 0 || next > max) return;
   el.scrollLeft = next; e.preventDefault();
 }, { passive: false });
}
/* Somlos loop: punkterna dupliceras en gang och scrollLeft nollstalls vid
  halva bredden. Auto pausar sa fort besokaren ror sparet. */
startAuto(speed) {
 var t = this.track, self = this, paused = false;
 try { t.insertAdjacentHTML('beforeend', t.innerHTML); } catch (e) {}
 ['pointerenter', 'touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { t.addEventListener(ev, function () { paused = true; }, { passive: true }); });
 ['pointerleave', 'touchend', 'pointercancel'].forEach(function (ev) { t.addEventListener(ev, function () { paused = false; }); });
 if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
 function step() {
   if (!paused && t.scrollWidth > t.clientWidth) {
     var half = t.scrollWidth / 2;
     t.scrollLeft += speed;
     if (t.scrollLeft >= half) t.scrollLeft -= half;
   }
   self._raf = requestAnimationFrame(step);
 }
 self._raf = requestAnimationFrame(step);
}
disconnectedCallback() { if (this._raf) cancelAnimationFrame(this._raf); if (this._fit) window.removeEventListener('resize', this._fit); }
}
customElements.define('on-product-bullets', OnProductBullets);
  })();

